/**
 * Input — GoodGuardian design system
 * Supports text, email, password, textarea, select
 */
export default function Input({
  label,
  type = 'text',
  value,
  onChange,
  placeholder,
  error,
  hint,
  required,
  disabled,
  rows = 4,
  options,      // For type="select": [{ value, label }]
  icon: Icon,
  className = '',
  ...props
}) {
  const inputCls =
    'input-base ' +
    (error ? 'border-red-400 focus:ring-red-400 ' : '') +
    (Icon ? 'pl-10 ' : '') +
    (disabled ? 'opacity-50 cursor-not-allowed ' : '') +
    className

  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label className="text-base font-semibold text-slate-700">
          {label}
          {required && <span className="text-red-500 ml-0.5">*</span>}
        </label>
      )}

      <div className="relative">
        {Icon && (
          <div className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none">
            <Icon className="w-4 h-4" />
          </div>
        )}

        {type === 'textarea' ? (
          <textarea
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            disabled={disabled}
            rows={rows}
            required={required}
            className={inputCls + ' resize-none'}
            {...props}
          />
        ) : type === 'select' ? (
          <select
            value={value}
            onChange={onChange}
            disabled={disabled}
            required={required}
            className={inputCls + ' appearance-none pr-8'}
            {...props}
          >
            {placeholder && <option value="">{placeholder}</option>}
            {options?.map(opt => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        ) : (
          <input
            type={type}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            disabled={disabled}
            required={required}
            className={inputCls}
            {...props}
          />
        )}
      </div>

      {error && <p className="text-sm text-red-500">{error}</p>}
      {hint && !error && <p className="text-sm text-slate-400">{hint}</p>}
    </div>
  )
}
